import { ArpAccess } from '../types'

type IsTokenGatedType = {
  edition?: any
  access?: ArpAccess
  userId?: number
} & Record<string, any>

type UserType = {
  id: number
} & Record<string, any>

// TODO make this work with token gates
export const isTokenGated = (item: IsTokenGatedType): boolean => {
  return item?.edition !== undefined && item?.edition !== null
  // return sp?.access !== undefined && sp?.access !== null && sp?.access !== ArpAccess.STANDARD
}

// whether a sample pack is gated just for uploading
export const isUploadTokenGated = (item: IsTokenGatedType): boolean => {
  return isTokenGated(item) && item.access === ArpAccess.UPLOAD_TOKEN_GATE
}

// whether a user can access the samples in a sample pack
export const canAccessSamplePack = (
  item: IsTokenGatedType,
  isTokenHolder: boolean,
  user?: UserType
): boolean => {
  if (!isTokenGated(item)) return true
  if (isUploadTokenGated(item)) return true
  if (isTokenGated(item) && (isTokenHolder || (item.userId && item.userId === user?.id))) {
    return true
  }
  return false
}
